export default "__VITE_ASSET__B2hae5AS__"